import { render, staticRenderFns } from "./step5_old.vue?vue&type=template&id=7eceea87&"
import script from "./step5_old.vue?vue&type=script&lang=js&"
export * from "./step5_old.vue?vue&type=script&lang=js&"
import style0 from "./step5_old.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/vuejs/project/school/arrisalah/ppdb/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VChip,VDataTable,VFlex,VIcon,VLayout,VSpacer})
